export const FETCH_DASHBOARD_HEADER_DATA = 'FETCH_DASHBOARD_HEADER_DATA';
export const FETCH_ALARM_SUMMARY_DATA = 'FETCH_ALARM_SUMMARY_DATA';
export const FETCH_CUSTOMER_HEALTH_DATA = 'FETCH_CUSTOMER_HEALTH_DATA';
export const FETCH_CHARGER_HEALTH_DATA = 'FETCH_CHARGER_HEALTH_DATA';
export const FETCH_CONNECTIVITY_MEDIUM_DATA = 'FETCH_CONNECTIVITY_MEDIUM_DATA';
export const SET_DASHBOARD_STATE_DATA = 'SET_DASHBOARD_STATE_DATA';
export const CLEAR_DASHBOARD_STATE_DATA = 'CLEAR_DASHBOARD_STATE_DATA';


export const CLEAR_NEW_DASHBOARD_DATA = 'CLEAR_NEW_DASHBOARD_DATA';

export const FETCH_NEW_DASHBOARD_HEADER_DATA = 'FETCH_NEW_DASHBOARD_HEADER_DATA';
export const FETCH_NEW_DASHBOARD_REAL_TIME_GUN_INFO = 'FETCH_NEW_DASHBOARD_REAL_TIME_GUN_INFO';
export const FETCH_NEW_DASHBOARD_CONNECTIVITY_MEDIUM_DATA = 'FETCH_NEW_DASHBOARD_CONNECTIVITY_MEDIUM_DATA';

export const FETCH_NEW_DASHBOARD_ACTIVE_ALARM_INFO = 'FETCH_NEW_DASHBOARD_ACTIVE_ALARM_INFO';
export const FETCH_NEW_DASHBOARD_ALARM_SEVERITY_INFO = 'FETCH_NEW_DASHBOARD_ALARM_SEVERITY_INFO';
export const FETCH_NEW_DASHBOARD_ALARM_OUTLIERS_LIST = 'FETCH_NEW_DASHBOARD_ALARM_OUTLIERS_LIST';
export const FETCH_NEW_DASHBOARD_ALARM_CLEAR_TIME_INFO = 'FETCH_NEW_DASHBOARD_ALARM_CLEAR_TIME_INFO';

export const FETCH_NEW_DASHBOARD_FAILED_TRANSACTION_LIST = 'FETCH_NEW_DASHBOARD_FAILED_TRANSACTION_LIST';
export const FETCH_NEW_DASHBOARD_FAILED_TRANSACTION_TOP_REASONS = 'FETCH_NEW_DASHBOARD_FAILED_TRANSACTION_TOP_REASONS';
export const SET_NEW_DASHBOARD_FAILED_TRANSACTION_LIST_FILTER_HASH = 'SET_NEW_DASHBOARD_FAILED_TRANSACTION_LIST_FILTER_HASH';
export const SET_NEW_DASHBOARD_FAILED_TRANSACTION_TOP_REASONS_FILTER_HASH = 'SET_NEW_DASHBOARD_FAILED_TRANSACTION_TOP_REASONS_FILTER_HASH';


export const FETCH_NEW_DASHBOARD_AI_INSIGHTS_LIST = 'FETCH_NEW_DASHBOARD_AI_INSIGHTS_LIST';
export const FETCH_NEW_CHARGING_SESSIONS_INFO = 'FETCH_NEW_CHARGING_SESSIONS_INFO';
export const FETCH_NEW_DASHBOARD_CHARGING_SESSION_TRENDS_INFO = 'FETCH_NEW_DASHBOARD_CHARGING_SESSION_TRENDS_INFO';
export const FETCH_NEW_DASHBOARD_CHARGING_VS_IDLE_INFO = 'FETCH_NEW_DASHBOARD_CHARGING_VS_IDLE_INFO';
export const FETCH_NEW_DASHBOARD_ENERGY_TREND_INFO = 'FETCH_NEW_DASHBOARD_ENERGY_TREND_INFO';
export const FETCH_NEW_DASHBOARD_OVERALL_UPTIME_INFO = 'FETCH_NEW_DASHBOARD_OVERALL_UPTIME_INFO';
export const FETCH_NEW_DASHBOARD_ALARM_SUMMARY_LIST = 'FETCH_NEW_DASHBOARD_ALARM_SUMMARY_LIST';
export const SET_NEW_DASHBOARD_ALARM_SUMMARY_FILTER_HASH = 'SET_NEW_DASHBOARD_ALARM_SUMMARY_FILTER_HASH';
export const FETCH_NEW_DASHBOARD_ALARM_SUMMARY_TABLE_LOADER = 'FETCH_NEW_DASHBOARD_ALARM_SUMMARY_TABLE_LOADER';
export const FETCH_NEW_DASHBOARD_ATTENTION_REQUIRED_DATA = 'FETCH_NEW_DASHBOARD_ATTENTION_REQUIRED_DATA';

export const SET_ATTENTION_REQUIRED_FILTER_HASH = 'SET_ATTENTION_REQUIRED_FILTER_HASH';
export const SET_NEW_DASHBOARD_UPTIME_FILTER_HASH = 'SET_DASHBOARD_OVERALL_UPTIME_FILTER_HASH';
export const SET_NEW_DASHDOARD_ENERGY_TREND_FILTER_HASH = 'SET_NEW_DASHDOARD_ENERGY_TREND_FILTER_HASH';
export const SET_DASHBOARD_CHARGING_VS_IDLE_FILTER_HASH = 'SET_DASHBOARD_CHARGING_VS_IDLE_FILTER_HASH';
export const SET_CHARGING_SESSION_TREND_FILTER_HASH = 'SET_CHARGING_SESSION_TREND_FILTER_HASH';
export const SET_NEW_DASHBOARD_CHARGING_SESSION_FILTER_HASH = 'SET_CHARGING_SESSION_FILTER_HASH';
export const SET_NEW_DASHBOARD_INSIGHTS_FILTER_HASH = 'SET_NEW_DASHBOARD_INSIGHTS_FILTER_HASH';
export const SET_NEW_DASHBOARD_REALTIME_GUN_INFO_FILTER_HASH = 'SET_NEW_DASHBOARD_REALTIME_GUN_INFO_FILTER_HASH';
export const SET_NEW_DASHBOARD_HEADER_FILTER_HASH = 'SET_NEW_DASHBOARD_HEADER_FILTER_HASH';
export const SET_NEW_DASHBOARD_CONNECTIVITY_MEDIUM_FILTER_HASH = 'SET_NEW_DASHBOARD_CONNECTIVITY_MEDIUM_FILTER_HASH';

export const FETCH_NEW_DASHBOARD_EFFICIENCY_TREND_INFO = 'FETCH_NEW_DASHBOARD_EFFICIENCY_TREND_INFO';
export const SET_NEW_DASHDOARD_EFFICIENCY_TREND_FILTER_HASH = 'SET_NEW_DASHDOARD_EFFICIENCY_TREND_FILTER_HASH';
export const FETCH_NEW_DASHBOARD_REACTIVE_ENERGY_CONSUMPTION_TREND_INFO = 'FETCH_NEW_DASHBOARD_REACTIVE_ENERGY_CONSUMPTION_TREND_INFO';
export const SET_NEW_DASHDOARD_REACTIVE_ENERGY_CONSUMPTION_TREND_FILTER_HASH = 'SET_NEW_DASHDOARD_REACTIVE_ENERGY_CONSUMPTION_TREND_FILTER_HASH';
